import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import { ACCRUALS_QUERY_KEY } from "./constants";
import { buildAccrualsQuery, type AccrualsFilters } from "./accruals-filters";
import type { AccrualsPageResponse } from "./types";

/**
 * Hand-written fetch — see CLAUDE.md → TD-07. `GET /api/admin/payouts/accruals`
 * (API-FIN-4) is the per-chunk detail behind a pending balance, read tier
 * ADMIN + FINANCE. Filterable by venue / subscription, paginated.
 */
export function useAccruals(filters: AccrualsFilters) {
  return useQuery({
    queryKey: [
      ...ACCRUALS_QUERY_KEY,
      filters.venueId.trim(),
      filters.subscriptionId.trim(),
      filters.page,
    ] as const,
    queryFn: () =>
      httpClient<AccrualsPageResponse>(`/api/admin/payouts/accruals${buildAccrualsQuery(filters)}`),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}
